import { z } from 'zod';
import { IncidentStatusTabSchema } from '@/features/stacktrace/incidents/-constants';
import { IncidentCategory, IncidentPriority, IncidentSeverity, IncidentStatusTab } from '@/features/stacktrace/incidents/-query/type';
import { IncidentTableColumns } from './-table/type';
const severityValues = Object.values(IncidentSeverity) as [IncidentSeverity, ...IncidentSeverity[]];
const categoryValues = Object.values(IncidentCategory) as [IncidentCategory, ...IncidentCategory[]];
const priorityValues = Object.values(IncidentPriority) as [IncidentPriority, ...IncidentPriority[]];

/**
 * インシデント一覧画面の URL search スキーマ。
 *
 * - status:         ステータスタブ用フィルタ (all + 4 バケット値)
 * - severity:       重大度ドロップダウンフィルタ (単一選択・クリア可)
 * - category:       分類ドロップダウンフィルタ (単一選択・クリア可)
 * - priority:       優先度ドロップダウンフィルタ (単一選択・クリア可)
 * - freeText:       検索 (インシデント No / 表題 部分一致 → API の keyword)
 * - pageIndex:      0-origin ページ番号
 * - pageSize:       1 ページあたりの件数
 * - sortColumn:     ソート対象カラム (既定: コード)
 * - orderDirection: ソート方向 (既定: 昇順)
 */
export const IncidentListPageFilterSchema = z.object({
  status: IncidentStatusTabSchema.default(IncidentStatusTab.OPEN),
  severity: z.enum(severityValues).optional(),
  category: z.enum(categoryValues).optional(),
  priority: z.enum(priorityValues).optional(),
  freeText: z.string().optional(),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  sortColumn: z.nativeEnum(IncidentTableColumns).default(IncidentTableColumns.CODE),
  orderDirection: z.enum(['asc', 'desc']).default('asc')
});